import {
    GET_DATA_FAIL,
    GET_DATA_SUCCESS,
    GET_DATA_START,
    GET_QUARTER_DATA_START,
    GET_QUARTER_DATA_SUCCESS,
    GET_QUARTER_CHART_START,
    GET_QUARTER_CHART_SUCCESS,
    GET_QUARTER_DSP_CHART_START,
    GET_QUARTER_DSP_CHART_SUCCESS,
    GET_QUARTER_TERRITORY_CHART_START,
    GET_QUARTER_TERRITORY_CHART_SUCCESS,
    GET_ASSET_PROFILE_START,
    GET_ASSET_PROFILE_SUCCESS,
    GET_TOPS_QUARTER_START,
    GET_TOPS_QUARTER_SUCCESS,
    GET_QUARTER_TERRITORY_CHART_STREAMS_START,
    GET_QUARTER_TERRITORY_CHART_STREAMS_SUCESS,
    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_START,
    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_SUCESS,
    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_ISRC_START,
    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_ISRC_SUCESS,
    GET_QUARTER_TERRITORY_CHART_STREAMS_ISRC_START,
    GET_QUARTER_TERRITORY_CHART_STREAMS_ISRC_SUCESS,
    GET_ISRC_DSP_CHART_START,
    GET_ISRC_DSP_CHART_SUCESS,
    GET_ISRC_CHART_DATE_START,
    GET_ISRC_CHART_DATE_SUCESS,
    GET_QUARTER_ACTIVITY_CHART_START,
    GET_QUARTER_ACTIVITY_CHART_SUCCESS,
    GET_IMPERSONATION_LIST_START,
    GET_IMPERSONATION_LIST_SUCCESS,
    SET_IMPERSONATION_LIST_START,
    SET_IMPERSONATION_LIST_SUCCESS,
    GET_LIVE_CHART_DATE_START,
    GET_LIVE_CHART_DATE_SUCESS,
    GET_LIVE_DATA_ISRC,
    GET_LIVE_DATA_ISRC_SUCCESS,
    SET_UNIT_TYPE,
    GET_CURRENT_RECIPIENT,
    GET_CURRENT_RECIPIENT_SUCCESS,
    SET_LOGIN_START,
    SET_LOGIN_SUCCESS,
    SET_EMAIL_START,
    SET_EMAIL_SUCCESS,
    GET_GROWTH_CHART,
    GET_GROWTH_CHART_SUCCESS,
    SET_AUDIOURL,
    GET_PRODUCT_PROFILE_START,
    GET_PRODUCT_PROFILE_SUCCESS,
    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_UPC_START,
    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_UPC_SUCESS,
    GET_QUARTER_TERRITORY_CHART_STREAMS_UPC_START,
    GET_QUARTER_TERRITORY_CHART_STREAMS_UPC_SUCESS,
    GET_UPC_DSP_CHART_START,
    GET_UPC_DSP_CHART_SUCESS,
    GET_UPC_CHART_DATE_SUCESS,
    GET_UPC_CHART_DATE_START,
    GET_ASSETS_FROM_UPC_START,
    GET_ASSETS_FROM_UPC_SUCESS,
    GET_PRODUCTS_FROM_ISRC_START,
    GET_PRODUCTS_FROM_ISRC_SUCESS,
    GET_TOPS_MONTH,
    GET_TOPS_MONTH_SUCCESS,
    GET_CATALOGUE_PROFILE_START,
    GET_CATALOGUE_PROFILE_SUCCESS,   
    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_CATALOGUE_START,
    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_CATALOGUE_SUCESS,
    GET_QUARTER_TERRITORY_CHART_STREAMS_CATALOGUE_START,
    GET_QUARTER_TERRITORY_CHART_STREAMS_CATALOGUE_SUCESS,
    GET_CATALOGUE_DSP_CHART_START,
    GET_CATALOGUE_DSP_CHART_SUCESS,
    GET_CATALOGUE_CHART_DATE_START,
    GET_CATALOGUE_CHART_DATE_SUCESS,
    GET_ASSETS_FROM_CATALOGUE_START,
    GET_ASSETS_FROM_CATALOGUE_SUCESS,
    GET_CATALOGUES_START,
    GET_CATALOGUES_SUCCESS,
    GET_PRODUCTS_START,
    GET_PRODUCTS_SUCCESS,
    GET_PRODUCT_TOTALS,
    GET_PRODUCT_TOTALS_SUCCESS,
    GET_ASSET_TOTALS,
    GET_ASSET_TOTALS_SUCCESS,
    GET_CATALOGUE_TOTALS,
    GET_CATALOGUE_TOTALS_SUCCESS,
    SET_ARTIST_SEARCH,
    SET_TITLE_SEARCH,
    GET_CATALOGUES_SEARCH_START,
    GET_CATALOGUES_SEARCH_SUCCESS,
    GET_GENRES_START,
    GET_GENRES_SUCCESS,
    SET_GENRES_SEARCH,
    SET_CATALOGUES_SEARCH,
    SET_ISRC_SEARCH,
    GET_SEARCH_DATA,
    GET_SEARCH_SUCCESS,

} from '../Types';
import axios from 'axios';
import { history } from '../../index'

const SERVER_URL = "";


export const actionCreators = {

    test: () => async (dispatch, getState) => {

       

        dispatch({ type: "TEST_START" });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/auth/test`;
        var request = new Request(url, {
            headers
        });

        const response = await fetch(request);
        if (response.ok) {
            const payload = await response.json();
            dispatch({ type: "TEST_FINISH", payload });
        } else if (response.status === 401) {
            getState().auth.isLogin = false;
            history.push('/signin');
            localStorage.removeItem('expiresAt');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('idToken');

        }
    },

    getSearchData: (nameQuery) => async (dispatch, getState) => {
        if (!getState().data.isLoadingSearch) {
            dispatch({ type: GET_SEARCH_DATA, nameQuery });
            var headers = new Headers();
            headers.append('Content-type', 'application/json')
            headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
            const url = `api/data/getAssetsByFilter`;
            var request = new Request(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(nameQuery)
            });
            try {
                const response = await fetch(request);
                const data = await response.json();

                dispatch({ type:GET_SEARCH_SUCCESS, data, nameQuery });
            } catch (e) {
                console.error(e);
            }
        }
    }, 
    SetISRC: (data) => async (dispatch) => {
        dispatch({ type: SET_ISRC_SEARCH, data });
    },
    SetGenres: (data) => async (dispatch) => {
        dispatch({ type: SET_GENRES_SEARCH, data });
    },
    SetCatalogues: (data) => async (dispatch) => {
        dispatch({ type: SET_CATALOGUES_SEARCH, data });
    },
    requestCatalogues: () => async (dispatch, getState) => {
      
        if ((getState().data.cataloguesSearch && getState().data.cataloguesSearch.length > 0) || getState().data.isLoadingCataloguesSearch ) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_CATALOGUES_SEARCH_START });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetCatalogItems`;
        var request = new Request(url, {
            headers
        });

        const response = await fetch(request);
        if (response.ok) {
            const payload = await response.json();
            dispatch({ type: GET_CATALOGUES_SEARCH_SUCCESS, payload });
        } else if (response.status === 401) {
            getState().auth.isLogin = false;
            history.push('/signin');
            localStorage.removeItem('expiresAt');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('idToken');

        }
    },
    requestGenres: () => async (dispatch, getState) => {

        if ((getState().data.genres && getState().data.genres.length  > 0 )) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_GENRES_START });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetGenres`;
        var request = new Request(url, {
            headers
        });

        const response = await fetch(request);
        if (response.ok) {
            const payload = await response.json();
            dispatch({ type: GET_GENRES_SUCCESS, payload });
        } else if (response.status === 401) {
            getState().auth.isLogin = false;
            history.push('/signin');
            localStorage.removeItem('expiresAt');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('idToken');

        }
    },
    setAssetArtist: (data) => async (dispatch) => {       
            dispatch({ type: SET_ARTIST_SEARCH, data });
    },
    setAssetTitle: (data) => async (dispatch) => {
        dispatch({ type: SET_TITLE_SEARCH, data });
    },
    getCatalogTotals: (code) => async (dispatch, getState) => {

        if (code === getState().data.catalogueTotalsCode) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_CATALOGUE_TOTALS });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/Gettotals?code=${code}&type=catalogue`;
        var request = new Request(url, {
            headers
        });

        const response = await fetch(request);
        if (response.ok) {
            const payload = await response.json();
            dispatch({ type: GET_CATALOGUE_TOTALS_SUCCESS, payload });
        } else if (response.status === 401) {
            getState().auth.isLogin = false;
            history.push('/signin');
            localStorage.removeItem('expiresAt');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('idToken');

        }
    },
    getProductTotals: (code) => async (dispatch, getState) => {

        if (code === getState().data.productTotalsCode) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_PRODUCT_TOTALS });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/Gettotals?code=${code}&type=product`;
        var request = new Request(url, {
            headers
        });

        const response = await fetch(request);
        if (response.ok) {
            const payload = await response.json();
            dispatch({ type: GET_PRODUCT_TOTALS_SUCCESS, payload });
        } else if (response.status === 401) {
            getState().auth.isLogin = false;
            history.push('/signin');
            localStorage.removeItem('expiresAt');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('idToken');

        }
    },
    getAssetTotals: (code) => async (dispatch, getState) => {

        if (code === getState().data.assetTotalsCode) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_ASSET_TOTALS });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/Gettotals?code=${code}&type=asset`;
        var request = new Request(url, {
            headers
        });

        const response = await fetch(request);
        if (response.ok) {
            const payload = await response.json();
            dispatch({ type: GET_ASSET_TOTALS_SUCCESS, payload });
        } else if (response.status === 401) {
            getState().auth.isLogin = false;
            history.push('/signin');
            localStorage.removeItem('expiresAt');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('idToken');

        }
    },
    getProductsData: () => async (dispatch, getState) => {

        if ((getState().data.productList && getState().data.productList !== null) || getState().data.isLoadingProductList) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_PRODUCTS_START });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetProducts`;
        var request = new Request(url, {
            headers
        });

        const response = await fetch(request);
        if (response.ok) {
            const payload = await response.json();
            dispatch({ type: GET_PRODUCTS_SUCCESS, payload });
        } else if (response.status === 401) {
            getState().auth.isLogin = false;
            history.push('/signin');
            localStorage.removeItem('expiresAt');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('idToken');

        }
    },
    getCatalogueData: () => async (dispatch, getState) => {

        if ((getState().data.catalogueList && getState().data.catalogueList !== null) || getState().data.isLoadingCatalogueList) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_CATALOGUES_START });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetCatalogues`;
        var request = new Request(url, {
            headers
        });

        const response = await fetch(request);
        if (response.ok) {
            const payload = await response.json();
            dispatch({ type: GET_CATALOGUES_SUCCESS, payload });
        } else if (response.status === 401) {
            getState().auth.isLogin = false;
            history.push('/signin');
            localStorage.removeItem('expiresAt');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('idToken');

        }
    },
    getAssetsFromCatalogue: (Catalogue) => async (dispatch, getState) => {

        if (Catalogue === getState().data.assetCatalogue) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_ASSETS_FROM_CATALOGUE_START, Catalogue });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/getAssetsFromCatalogue?Catalogue=${Catalogue}`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_ASSETS_FROM_CATALOGUE_SUCESS, Catalogue, payload });
        } catch (e) {
            console.error(e);
        }
    },

    getCatalogueChartBydate: (Catalogue, chartType, startMonth, startYear, endMonth, endYear) => async (dispatch, getState) => {

        if (Catalogue === getState().data.chartCatalogue && chartType === getState().data.chartCatalogueType && startMonth === getState().data.chartCatalogueStartMonth
            && startYear === getState().data.chartCatalogueStartYear && endYear === getState().data.chartCatalogueEndYear && endMonth === getState().data.chartCatalogueEndMonth) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_CATALOGUE_CHART_DATE_START, Catalogue, chartType, startMonth, startYear, endMonth, endYear });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetCatalogueChartBydate?Catalogue=${Catalogue}&type=${chartType}&startMonth=${startMonth ? startMonth : ''}&startYear=${startYear}&endMonth=${endMonth ? endMonth : ''}&endYear=${endYear ? endYear : ''}`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_CATALOGUE_CHART_DATE_SUCESS, Catalogue, chartType, startMonth, startYear, endMonth, endYear, payload });
        } catch (e) {
            console.error(e);
        }
    },
    getDSPCatalogue: (Catalogue) => async (dispatch, getState) => {

        if (Catalogue === getState().data.dspCatalogue) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_CATALOGUE_DSP_CHART_START, Catalogue });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetCatalogueChartTypes?code=${Catalogue}&type=dsp`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_CATALOGUE_DSP_CHART_SUCESS, Catalogue, payload });
        } catch (e) {
            console.error(e);
        }
    },
    getTerritoryStreamsChartByCatalogue: (Catalogue) => async (dispatch, getState) => {

        if (Catalogue === getState().data.territoryStreamsCatalogue) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_QUARTER_TERRITORY_CHART_STREAMS_CATALOGUE_START, Catalogue });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetTerritoryChartByCatalogue?code=${Catalogue}&type=stream`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_QUARTER_TERRITORY_CHART_STREAMS_CATALOGUE_SUCESS, Catalogue, payload });
        } catch (e) {
            console.error(e);
        }

    },
    getTerritoryDownloadsChartByCatalogue: (catalogue) => async (dispatch, getState) => {

        if (catalogue === getState().data.territoryDownloadsCatalogue) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_QUARTER_TERRITORY_CHART_DOWNLOADS_CATALOGUE_START, catalogue });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetTerritoryChartByCatalogue?code=${catalogue}&type=download`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_QUARTER_TERRITORY_CHART_DOWNLOADS_CATALOGUE_SUCESS, catalogue, payload });
        } catch (e) {
            console.error(e);
        }

    },
    getCatalogProfile: (catalogue) => async (dispatch, getState) => {

        if (catalogue === getState().data.requestedCAT) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_CATALOGUE_PROFILE_START, catalogue });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetCatalogueData?catalogue=${catalogue}`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_CATALOGUE_PROFILE_SUCCESS, catalogue, payload });
        } catch (e) {
            console.error(e);
        }

    },
    getTopsMonth: (month, year, _type) => async (dispatch, getState) => {
        if (month === getState().data.topsMonth && year === getState().data.topsthYear && _type=== getState().data.topsType) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_TOPS_MONTH, month, year, _type });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/getTopsByMonth?month=${month}&year=${year}&type=${_type}`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_TOPS_MONTH_SUCCESS, month, year, _type, payload });
        } catch (e) {
            console.error(e);
        }
    },
    getProductsFromISRC: (isrc) => async (dispatch, getState) => {

        if (isrc === getState().data.productsISRC) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_PRODUCTS_FROM_ISRC_START, isrc });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/getProductsFromAsset?isrc=${isrc}`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_PRODUCTS_FROM_ISRC_SUCESS, isrc, payload });
        } catch (e) {
            console.error(e);
        }
    },

    getAssetsFromUPC: (upc) => async (dispatch, getState) => {

        if (upc === getState().data.assetUPC) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_ASSETS_FROM_UPC_START, upc });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/getAssetsFromProduct?upc=${upc}`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_ASSETS_FROM_UPC_SUCESS, upc, payload });
        } catch (e) {
            console.error(e);
        }
    },

    getUPCChartBydate: (upc, chartType, startMonth, startYear, endMonth, endYear) => async (dispatch, getState) => {

        if (upc === getState().data.chartUPC && chartType === getState().data.chartUPCType && startMonth === getState().data.chartUPCStartMonth
            && startYear === getState().data.chartUPCStartYear && endYear === getState().data.chartUPCEndYear && endMonth === getState().data.chartUPCEndMonth) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_UPC_CHART_DATE_START, upc, chartType, startMonth, startYear, endMonth, endYear });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetUPCChartBydate?upc=${upc}&type=${chartType}&startMonth=${startMonth ? startMonth : ''}&startYear=${startYear}&endMonth=${endMonth ? endMonth : ''}&endYear=${endYear ? endYear : ''}`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_UPC_CHART_DATE_SUCESS, upc, chartType, startMonth, startYear, endMonth, endYear, payload });
        } catch (e) {
            console.error(e);
        }
    },
    getDSPUPC: (upc) => async (dispatch, getState) => {

        if (upc === getState().data.dspUPC) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_UPC_DSP_CHART_START, upc });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetUPCChartTypes?upc=${upc}&type=dsp`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_UPC_DSP_CHART_SUCESS, upc, payload });
        } catch (e) {
            console.error(e);
        }
    },
    getTerritoryStreamsChartByUPC: (upc) => async (dispatch, getState) => {

        if (upc === getState().data.territoryStreamsUPC) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_QUARTER_TERRITORY_CHART_STREAMS_UPC_START, upc });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetTerritoryChartByUPC?upc=${upc}&type=stream`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_QUARTER_TERRITORY_CHART_STREAMS_UPC_SUCESS, upc, payload });
        } catch (e) {
            console.error(e);
        }

    },

    setAudioUrl: (url,meta) => async (dispatch) => {
        if (url)
            dispatch({ type: SET_AUDIOURL, url, meta });
    },
    setUnitType: (unit) => (dispatch) => {
       
        dispatch({ type: SET_UNIT_TYPE, unit: unit });
    },
    getLiveDataIsrc: (isrc, startDate, endDate, unitType) => async (dispatch, getState) => {
        if (getState().data.liveDataISRCrequested === isrc && getState().data.liveDataISRCunitTypeRequested === unitType &&
            getState().data.liveDataISRCstartDate === startDate && getState().data.liveDataISRCendDate === endDate)
            return

        dispatch({ type: GET_LIVE_DATA_ISRC, isrc, unitType, endDate, startDate });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/getLiveDspTotalChartByISRCDate?isrc=${isrc}&startDate=${startDate}&endDate=${endDate}&unitType=${unitType}`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_LIVE_DATA_ISRC_SUCCESS, payload, isrc, unitType, endDate, startDate });
        } catch (e) {
            console.error(e);
        }

    },

    getLiveDSPChartBydate: () => async (dispatch, getState) => {

        if (getState().data.liveStreamData !== null) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_LIVE_CHART_DATE_START });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/getLiveDspTotalChartByDate`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_LIVE_CHART_DATE_SUCESS, payload });
        } catch (e) {
            console.error(e);
        }
    },
    getData: () => async (dispatch, getState) => {
        

        dispatch({ type: GET_DATA_START });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetFullTracks`;
        var request = new Request(url, {
            headers
        });

        const response = await fetch(request);
        if (response.ok) {
            const payload = await response.json();

            dispatch({ type: GET_DATA_SUCCESS, payload });
        } else if (response.status === 401) {
            localStorage.removeItem('expiresAt');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('idToken');
                 getState().auth.isLogin = false;
                    history.push('/signin');           
        }
        
    },

    getAssetData: () => async (dispatch, getState) => {

        if ((getState().data.quarterList && getState().data.quarterList !== null) || getState().data.isLoading) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_QUARTER_DATA_START });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetSummaryByQuarter`;
        var request = new Request(url, {
            headers
        });

        const response = await fetch(request);
        if (response.ok) {
        const payload = await response.json();
            dispatch({ type: GET_QUARTER_DATA_SUCCESS, payload });
        } else if (response.status === 401) {
            getState().auth.isLogin = false;
            history.push('/signin');
            localStorage.removeItem('expiresAt');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('idToken');

        }
    },
    getQuarterActivityChart: (quarter) => async (dispatch, getState) => {

        if (quarter === getState().data.activityQuarter) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }
        dispatch({ type: GET_QUARTER_ACTIVITY_CHART_START, quarter });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetQuarterChart?quarter=${quarter}`;
        var request = new Request(url, {
            headers
        });

        const response = await fetch(request);
        if (response.ok) {
            const payload = await response.json();          
            dispatch({ type: GET_QUARTER_ACTIVITY_CHART_SUCCESS, quarter, payload });
        } else if(response.status === 401) {
            getState().auth.isLogin = false;
            localStorage.removeItem('expiresAt');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('idToken');
            history.push('/signin');
            
        }
       
    },
    getGrowth: (month, year) => async (dispatch, getState) => {        
        if (month === getState().data.growthMonth && year === getState().data.growthYear) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_GROWTH_CHART, month, year });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/getGrowthTable?month=${month}&year=${year}`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_GROWTH_CHART_SUCCESS, month, year, payload });
        } catch (e) {
            console.error(e);
        }
    },

    getDSPQuarter: (quarter) => async (dispatch, getState) => {

        if (quarter === getState().data.dspQuarter) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_QUARTER_DSP_CHART_START, quarter });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetQuarterChartTypes?quarter=${quarter}&type=dsp`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            if (response.ok) {
                const payload = await response.json();
                dispatch({ type: GET_QUARTER_DSP_CHART_SUCCESS, quarter, payload });
            } else if (response.status === 401) {
                localStorage.removeItem('expiresAt');
                localStorage.removeItem('refreshToken');
                localStorage.removeItem('accessToken');
                localStorage.removeItem('idToken');
                getState().auth.isLogin = false;
                history.push('/signin');   
            }
       
        } catch (e) {
            console.error(e);
        }
    },
    getTerritoryQuarter: (quarter) => async (dispatch, getState) => {

        if (quarter === getState().data.territoryQuarter) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_QUARTER_TERRITORY_CHART_START, quarter });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetQuarterChartTypes?quarter=${quarter}&type=territory`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_QUARTER_TERRITORY_CHART_SUCCESS, quarter, payload });
        } catch (e) {
            console.error(e);
        }
      
    },
    getAssetProfile: (isrc) => async (dispatch, getState) => {

        if (isrc === getState().data.requestedISRC) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_ASSET_PROFILE_START, isrc });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetAssetData?isrc=${isrc}`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_ASSET_PROFILE_SUCCESS, isrc, payload });
        } catch (e) {
            console.error(e);
        }
      
    },

    getProductProfile: (upc) => async (dispatch, getState) => {

        if (upc === getState().data.requestedUPC) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_PRODUCT_PROFILE_START, upc });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetProductData?upc=${upc}`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_PRODUCT_PROFILE_SUCCESS, upc, payload });
        } catch (e) {
            console.error(e);
        }

    },


    getTopsQuarter: (quarter) => async (dispatch, getState) => {

        if (quarter === getState().data.topsQuarter) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_TOPS_QUARTER_START, quarter });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetQuarterTops?quarter=${quarter}`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_TOPS_QUARTER_SUCCESS, quarter, payload });
        } catch (e) {
            console.error(e);
        }

    },
    getTerritoryStreamsQuarterChart: (quarter) => async (dispatch, getState) => {

        if (quarter === getState().data.territoryStreamsQuarter) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_QUARTER_TERRITORY_CHART_STREAMS_START, quarter });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetQuarterTerritoryChartTypes?quarter=${quarter}&type=stream`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_QUARTER_TERRITORY_CHART_STREAMS_SUCESS, quarter, payload });
        } catch (e) {
            console.error(e);
        }

    },
    getTerritoryDownloadsQuarterChart: (quarter) => async (dispatch, getState) => {

        if (quarter === getState().data.territoryDownloadsQuarter) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_QUARTER_TERRITORY_CHART_DOWNLOADS_START, quarter });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetQuarterTerritoryChartTypes?quarter=${quarter}&type=download`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_QUARTER_TERRITORY_CHART_DOWNLOADS_SUCESS, quarter, payload });
        } catch (e) {
            console.error(e);
        }

    },

    getTerritoryStreamsChartByIsrc: (isrc) => async (dispatch, getState) => {

        if (isrc === getState().data.territoryStreamsIsrc) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_QUARTER_TERRITORY_CHART_STREAMS_ISRC_START, isrc });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetTerritoryChartByIsrc?isrc=${isrc}&type=stream`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_QUARTER_TERRITORY_CHART_STREAMS_ISRC_SUCESS, isrc, payload });
        } catch (e) {
            console.error(e);
        }

    },
    getTerritoryDownloadsChartByIsrc: (isrc) => async (dispatch, getState) => {

        if (isrc === getState().data.territoryDownloadsIsrc) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_QUARTER_TERRITORY_CHART_DOWNLOADS_ISRC_START, isrc });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetTerritoryChartByIsrc?isrc=${isrc}&type=download`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_QUARTER_TERRITORY_CHART_DOWNLOADS_ISRC_SUCESS, isrc, payload });
        } catch (e) {
            console.error(e);
        }

    },
    getTerritoryDownloadsChartByUPC: (upc) => async (dispatch, getState) => {

        if (upc === getState().data.territoryDownloadsUPC) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_QUARTER_TERRITORY_CHART_DOWNLOADS_UPC_START, upc });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetTerritoryChartByUPC?upc=${upc}&type=download`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_QUARTER_TERRITORY_CHART_DOWNLOADS_UPC_SUCESS, upc, payload });
        } catch (e) {
            console.error(e);
        }

    },
    getDSPIsrc: (isrc) => async (dispatch, getState) => {

        if (isrc === getState().data.dspISRC) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_ISRC_DSP_CHART_START, isrc });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetISRCChartTypes?isrc=${isrc}&type=dsp`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_ISRC_DSP_CHART_SUCESS, isrc, payload });
        } catch (e) {
            console.error(e);
        }
    },
    getISRCChartBydate: (isrc, chartType,startMonth, startYear, endMonth, endYear) => async (dispatch, getState) => {

        if (isrc === getState().data.chartIsrc && chartType === getState().data.chartIsrcType && startMonth === getState().data.chartIsrcStartMonth
            && startYear === getState().data.chartIsrcStartYear && endYear === getState().data.chartIsrcEndYear && endMonth === getState().data.chartIsrcEndMonth) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_ISRC_CHART_DATE_START, isrc, chartType, startMonth, startYear, endMonth, endYear });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetISRCChartBydate?isrc=${isrc}&type=${chartType}&startMonth=${startMonth ? startMonth : ''}&startYear=${startYear}&endMonth=${endMonth ? endMonth : ''}&endYear=${endYear ? endYear:''}`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_ISRC_CHART_DATE_SUCESS, isrc, chartType, startMonth, startYear, endMonth, endYear, payload });
        } catch (e) {
            console.error(e);
        }
    },
    getRecipientList: () => async (dispatch, getState) => {

        if (getState().recipientList || getState().recipientListLoading === true) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        dispatch({ type: GET_IMPERSONATION_LIST_START });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetRecipients`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();           
            dispatch({ type: GET_IMPERSONATION_LIST_SUCCESS, payload });
        } catch (e) {
            console.error(e);
        }
    },
    setRecipientImpersonation: (id) => async (dispatch, getState) => {

        if (getState().recipientID) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }
        let data = { account_id: id };
        dispatch({ type: SET_IMPERSONATION_LIST_START });
        var headers = new Headers();
        headers.append('Content-type', 'application/json')
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/SetImpersonation`;
        var request = new Request(url, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: SET_IMPERSONATION_LIST_SUCCESS, id, payload });
        } catch (e) {
            console.error(e);
        }
    },
    getRecipient: () => async (dispatch, getState) => {

        if (getState().currentRecipientImper) {
           
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }
      
        dispatch({ type: GET_CURRENT_RECIPIENT });
        var headers = new Headers();
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/GetImpersonatingRecipient`;
        var request = new Request(url, {
            headers
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: GET_CURRENT_RECIPIENT_SUCCESS, payload });
        } catch (e) {
            console.error(e);
        }
    },
    setRecipientLogin: (id,email,password) => async (dispatch,getState) => {

        if (getState().recipientLoginSaving) {
            return;
        }
        let data = { recipientID: id, email: email, password: password };
       
        dispatch({ type: SET_LOGIN_START });
        var headers = new Headers();
        headers.append('Content-type', 'application/json')
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/auth/recipientLogin`;
        var request = new Request(url, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: SET_LOGIN_SUCCESS, id, payload });
        } catch (e) {
            console.error(e);
        }
    },
    setRecipientEmail: (id, email) => async (dispatch) => {

        let data = { account_id: id, email: email };
        console.info(data);
        dispatch({ type: SET_EMAIL_START });
        var headers = new Headers();
        headers.append('Content-type', 'application/json')
        headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
        const url = `api/data/SetRecipientEmail`;
        var request = new Request(url, {
            method: 'POST',
            headers,
            body: JSON.stringify(data)
        });
        try {
            const response = await fetch(request);
            const payload = await response.json();
            dispatch({ type: SET_EMAIL_SUCCESS, id, payload });
        } catch (e) {
            console.error(e);
        }
    },
    
};

   

export const getDataOld = (callback) => {
    return async (dispatch) => {

        var header = {
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
        }
        //axios.defaults.headers.get['Authorization'] = `Bearer ${localStorage.getItem('accessToken')}`;
        try {
            let response = await axios.get(`${SERVER_URL}api/auth/changePassword`, header);
            dispatch({
                type: GET_DATA_SUCCESS,
                payload: response
            });

            if (callback)
                callback({
                    succeed: true,
                    error: ''
                });
        } catch (error) {
            if (callback)
                callback({
                    succeed: false,
                    error: 'something went wrong!'
                });
        }
    }

}








// WEBPACK FOOTER //
// ./src/store/actions/dataActions.js